import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PRSDetail from './PRSDetail';

const PRSDetailModal = ({ selectedLog, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>payable reminder activity log detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PRSDetail selectedLog={selectedLog} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

PRSDetailModal.propTypes = {
  selectedLog: PropTypes.instanceOf(Object).isRequired,
};

export default PRSDetailModal;
